import React from 'react';
import classnames from 'classnames';
import {NeuroMessage} from '@ignitesales/neuro-application/src/neuro-guide';

const Footer = ({className}) => {
  const classes = classnames(
    'footer',
    className
  );

  const year = new Date().getFullYear();

  return <>
    <footer className={classes}>
      <div className={`component component--twoThird ${classes}__legal`}>
        <p className="copyright"><NeuroMessage id="footer.copyright.lead" /> {year} <NeuroMessage id="footer.copyright.bankName" /></p>
        <NeuroMessage id="footer.housing" tagName='p' className="housing"/>
        <NeuroMessage id="footer.privacy" tagName='p' className="privacy"/>
      </div>

      <div className={`component component--third ${classes}__logos`}>
        <img src="/classpath/assets/images/icons/logo-equal-housing.png" />
        <img src="/classpath/assets/images/icons/logo-visa.png" />
        <img src="/classpath/assets/images/icons/logo-ncua.png" />
        <img src="/classpath/assets/images/icons/logo-cdfi.png" />
      </div>
    </footer>
  </>;
};

export default Footer;
